module.exports = __webpack_public_path__ + "media/images/ups-grayscale-5ad466dd31042bac7bde6115f268f552.jpg";